import * as React from 'react'
import './searchFooter.scss'
import { useTranslation } from 'translations'

interface SearchFooterProps {
    loading: boolean
    hasQuery: boolean
    totalResults: number
}

export function SearchFooter({ loading, hasQuery, totalResults }: SearchFooterProps): JSX.Element {
    const { t } = useTranslation()
    return (
        <div className="global-search-footer">
            <span className="global-search-key-hint">
                <kbd>&uarr;</kbd>
                <kbd>&darr;</kbd> {t('globalSearch.footer.navigate')}
            </span>
            <span className="global-search-key-hint">
                <kbd>&crarr;</kbd> {t('globalSearch.footer.open')}
            </span>
            <span className="global-search-footer-status" role="status" aria-live="polite">
                {loading
                    ? t('globalSearch.searching')
                    : hasQuery
                    ? t('globalSearch.footer.results', { total: totalResults })
                    : null}
            </span>
        </div>
    )
}
